
import React, { useEffect, useState } from "react";
import "../CreateJuryRound/CreateJuryRoundPost.scss";
import { IoMdAddCircleOutline, IoMdInformationCircle } from "react-icons/io";
import TimePicker from "react-time-picker";
import { useNavigate, useParams } from "react-router-dom";
import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../../TopBar/TopBar";
import './scoreCard.scss'
import {
  CheckboxInput,
  CheckLabel,
  InputLabel,
  InputType,
  SelectBorder,
} from "../../../../Global/GlobalFormElement";
import {
  GreyBackgroundButton,
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../../Global/GlobalButton";
import { RedMainHeading } from "../../../../Global/GlobalText";
import { MdEditSquare, MdOutlineSettings } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { MultiSelect } from "react-multi-select-component";
import { IoCopy } from "react-icons/io5";
import axios from "axios";
import { useSelector } from "react-redux";
import { EXCHNAGE_URL } from "../../../../../Url/Url";
import FormCanvas from "./EntryFormChild/FormCanvas";
import EditFieldModal from "./EntryFormChild/EditFieldModal";
import CreateScoreCard from "./CreateScoreCard";
import { toast } from "react-toastify";
import { FaInfoCircle } from "react-icons/fa";
import { useLoading } from "../../../../LoadingContext"; // ✅ ADD THIS

const ScoreCardData = ({ ScoreCardValue, totalScorecards }) => {
  const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader

  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const initialEventId = String(eventIdGet);
  const { roundId } = useParams();

  const [scorecardData, setScorecardData] = useState([]);
  const [singleScoreCardData, setSingleScoreCardData] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [formFields, setFormFields] = useState([]);
  const [fields, setFields] = useState([]);
  const [numFields, setNumFields] = useState(fields.length);
  const [isValid, setIsValid] = useState(true);
  const [formula, setFormula] = useState('');
  const [loader, setLoader] = useState(false)
  const [sortOrder, setSortOrder] = useState("newest");
  const [searchTerm, setSearchTerm] = useState("");
  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [generatedSchema, setGeneratedSchema] = useState(null);
  const [currentField, setCurrentField] = useState(null);
  const [formValues, setFormValues] = useState({
    category: ""
  })
  const [titleValue, setTitleValue] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [selectedScorecard, setSelectedScorecard] = useState(null);
  const [mode, setMode] = useState('');
  const [scoreCardValue, setScoreCardValue] = useState("")
  const [copiedFields, setCopiedFields] = useState([]);
  const [isShowDivVisible, setIsShowDivVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isCreateCopyModalVisible, setIsCreateCopyModalVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategoryNames, setSelectedCategoryNames] = useState([]); 



  const token = localStorage.getItem("token")
  console.log(totalScorecards, "asdasdasd")
  const navigate = useNavigate();

  const validateFormula = (formula, fieldsCount) => {
    const tokens = formula.match(/(\{[0-9]+\}|[+\-*/()])/g);

    if (!tokens) return false;

    let openParentheses = 0;
    let lastToken = null;

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];

      if (token.match(/\{[0-9]+\}/)) {
        const placeholderIndex = parseInt(token.slice(1, -1), 10);
        if (placeholderIndex < 1 || placeholderIndex > fieldsCount) {
          return false;
        }
      }
      else if (token === '(') {
        openParentheses++;
      }
      else if (token === ')') {
        openParentheses--;
        if (openParentheses < 0) return false;
      }
      else if (['+', '-', '*', '/'].includes(token)) {
        if (!lastToken || ['+', '-', '*', '/'].includes(lastToken) || lastToken === '(') {
          return false;
        }
      } else {
        return false;
      }

      lastToken = token;
    }
    if (openParentheses !== 0) return false;

    if (lastToken === ')' || lastToken === '(') {
      return false;
    }

    return true;
  };


  const handleFormulaInput = (e) => {
    const inputValue = e.target.value;
    setFormula(inputValue);
    const isFormulaValid = validateFormula(inputValue, numFields);
    setIsValid(isFormulaValid);
  };

  const addDefaultFields = () => {
    setFields((prevFields) => {
      const updatedFields = [...prevFields, ...defaultFields];
      setFormula('');
      return updatedFields;
    });
  };

  const removeField = (index) => {
    const fieldToRemove = fields[index];
    if (fieldToRemove.isDefault) {
      alert("This field cannot be removed.");
    } else {
      const updatedFields = fields.filter((_, i) => i !== index);
      setFields(updatedFields);
      setFormula('');
    }
  };


  const defaultFields = [
    {
      fields: [
        {
          type: "text",
          label: "Title",
          dataName: `title-${Date.now()}`,
          placeholder: "Enter title...",
          value: "",
          minValue: "",
          maxValue: "",
          required: true
        },
        {
          type: "textarea",
          label: "Description",
          dataName: `description-${Date.now()}`,
          placeholder: "Enter description...",
          value: "",
          required: true
        },
      ],
    },
  ];

  const updateField = (updatedFields) => {
    setFields(updatedFields);
  };

  const handleCategoryChange = (e) => {
    setFormValues({ ...formValues, category: e.target.value });
  };

  const updateTitleAndDescription = (title, description) => {
    setTitleValue(title);
    setDescriptionValue(description);
  };


  const validateFields = () => {
    return fields.every(field => {
      return field.fields.every(subField => {
        if (subField.required) {
          return subField.value.trim() !== "";
        }
        return true;
      });
    });
  };


  const getCategories = async () => {
    setLoader(true)
        setLoading(true); // ✅ Start global loader

    try {
      let apiUrl = `${EXCHNAGE_URL}/allAwards?eventId=${initialEventId}&sortOrder=${sortOrder}`;
      if (searchTerm) {
        apiUrl += `&search=${searchTerm}`;
      }
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setAllCategories(response.data.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoader(false);
      setLoading(false); // ✅ Stop global loader
    }
  }
  const handleChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedId = selectedOption.getAttribute("data-id");
    const selectedName = selectedOption.value;

    if (!selectedId || selectedCategories.includes(Number(selectedId))) return;

    setSelectedCategories((prev) => [...prev, Number(selectedId)]); 
    setSelectedCategoryNames((prev) => [...prev, selectedName]);

    setFormValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: "",
    }));
  };

  console.log(selectedCategories, "adsasddsasda")

  const removeCategory = (idToRemove) => {
    const index = selectedCategories.indexOf(idToRemove);
    if (index !== -1) {
      setSelectedCategories((prev) => prev.filter((id) => id !== idToRemove));
      setSelectedCategoryNames((prev) => prev.filter((_, i) => i !== index));
    }
  };


  console.log(selectedCategoryId, "asdadasdasda")
  const handleUpdate = async () => {
    if (!selectedScorecard) return;

    if (!validateFields()) {
      toast.error("Please fill in all required fields."); // Show error message
      return;
    }
    if (!isValid && formula.trim() !== "") {
      toast.error("Please enter a valid formula in Overall value");
      return;
    }
    let hasMinMaxErrors = false;
    fields.forEach((field) => {
      if (field.hasOwnProperty("minValue") || field.hasOwnProperty("maxValue")) {
        if (!field.minValue || !field.maxValue) {
          toast.error(`Please Check, both Min and Max values are Required`);
          hasMinMaxErrors = true;
        }
      }

      if (field.fields) {
        field.fields.forEach((subField) => {
          if (subField.hasOwnProperty("minValue") || subField.hasOwnProperty("maxValue")) {
            if (!subField.minValue || !subField.maxValue) {
              toast.error(`Please Check, both Min and Max values are Required`);
              hasMinMaxErrors = true;
            }
          }
        });
      }
    });

    if (hasMinMaxErrors) return;
    setLoading(true); // ✅ Start global loader

    try {
      const updatedData = {
        eventId: initialEventId,
        scoreFormId: selectedScorecard.scoreFormId,
        form_schema: generatedSchema || fields,
        scorecard_categories: formValues.category ? [formValues.category] : [],
        roundId: roundId,
        categoryId: selectedCategoryId || "",
      };

      if (formula) {
        updatedData.overall_value = formula;
      }

      console.log(updatedData, "adsdsdadasdasdasdasd")
      const scoreFormId = selectedScorecard.scoreFormId;

      const response = await axios.put(`${EXCHNAGE_URL}/scorecard?eventId=${eventIdGet}&scoreFormId=${scoreFormId}&roundId=${roundId}`, updatedData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      toast.success('Scorecard updated successfully');
      setIsEditModalVisible(false);
      setSingleScoreCardData([]);
      setSelectedScorecard([]);
      setScorecardData(prevData =>
        prevData.map(scorecard =>
          scorecard.scoreFormId === scoreFormId ? { ...scorecard, ...response.data } : scorecard
        )
      );
      setIsShowDivVisible(false);
      setScorecardData([])
    } catch (error) {
      console.error(error);
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };


  console.log(fields, "aaaaaaaaksdmskdmsk")

  const handelSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      toast.error("Please fill in all required fields."); // Show error message
      return;
    }
    if (!isValid) {
      toast.error("Please Enter a valid Formula in Overall value");
      return;
    }
    let hasMinMaxErrors = false;
    fields.forEach((field) => {
      if (field.hasOwnProperty("minValue") || field.hasOwnProperty("maxValue")) {
        if (!field.minValue || !field.maxValue) {
          toast.error(`Please Check, both Min and Max values are Required`);
          hasMinMaxErrors = true;
        }
      }

      if (field.fields) {
        field.fields.forEach((subField) => {
          if (subField.hasOwnProperty("minValue") || subField.hasOwnProperty("maxValue")) {
            if (!subField.minValue || !subField.maxValue) {
              toast.error(`Please Check, both Min and Max values are Required`);
              hasMinMaxErrors = true;
            }
          }
        });
      }
    });

    if (hasMinMaxErrors) return;

    const formData = {
      eventId: initialEventId,
      roundId: roundId,
      form_schema: generatedSchema || fields,
      scorecard_categories: selectedCategoryNames || [],
      // overall_value: formula ? formula : "",
      categoryId: selectedCategories || [],
    };
    if (formula) {
      formData.overall_value = formula
    };
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.post(`${EXCHNAGE_URL}/scorecard`, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      toast.success("Scorecard created successfully!");
      setScoreCardValue(response.data.data.scoreFormId)
      console.log(response.data.data.scoreFormId, "999999999999")
      // navigate("/jury-round"); 
      setMode('');
      fetchData()
    } catch (error) {
      console.error(error);
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };

  const handelSubmitCopy = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      toast.error("Please fill in all required fields."); // Show error message
      return;
    }
    if (!isValid) {
      toast.error("Please Enter a valid Formula in Overall value");
      return;
    }
    let hasMinMaxErrors = false;
    fields.forEach((field) => {
      if (field.hasOwnProperty("minValue") || field.hasOwnProperty("maxValue")) {
        if (!field.minValue || !field.maxValue) {
          toast.error(`Please Check, both Min and Max values are Required`);
          hasMinMaxErrors = true;
        }
      }

      if (field.fields) {
        field.fields.forEach((subField) => {
          if (subField.hasOwnProperty("minValue") || subField.hasOwnProperty("maxValue")) {
            if (!subField.minValue || !subField.maxValue) {
              toast.error(`Please Check, both Min and Max values are Required`);
              hasMinMaxErrors = true;
            }
          }
        });
      }
    });

    if (hasMinMaxErrors) return;

    const formData = {
      eventId: initialEventId,
        scoreFormId: selectedScorecard.scoreFormId,
        form_schema: generatedSchema || fields,
        scorecard_categories: formValues.category ? [formValues.category] : [],
        roundId: roundId,
        categoryId: [selectedCategoryId] || [],
    };
    if (formula) {
      formData.overall_value = formula
    };
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.post(`${EXCHNAGE_URL}/scorecard`, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      toast.success("Scorecard created successfully!");
      setScoreCardValue(response.data.data.scoreFormId)
      console.log(response.data.data.scoreFormId, "999999999999")
      // navigate("/jury-round"); 
      setMode('');
      fetchData()
    } catch (error) {
      console.error(error);
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };
  const handleEditButtonClick = (scoreFormId, index) => {
    setMode('edit');
    setIsEditModalVisible(true);
    setIsCreateCopyModalVisible(false);
    const scorecard = scorecardData.find(item => item.scoreFormId === scoreFormId);
    if (scorecard) {
      setSelectedScorecard(scorecard);
      setSelectedIndex(index + 1);
      setIsShowDivVisible(true);
      const formSchema = JSON.parse(scorecard.form_schema);
      setFields(formSchema[0]?.fields || []);
      setFormula(scorecard.scorecard_categories?.[0]?.formula || '');
      const id = String(scorecard?.categoryId)
      setSelectedCategoryId(id)
      const selectedCategory = scorecard.scorecard_categories?.[0]?.ScoreCardCategory || '';
      setFormValues({ category: selectedCategory });
    }
  };

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedId = selectedOption.getAttribute("data-id") || "";
  
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value, 
    }));
    setSelectedCategoryId(selectedId); 
  };

  const handleCopyButtonClick = (scoreFormId) => {
    setMode('createCopy')
    setIsEditModalVisible(false);
    setIsCreateCopyModalVisible(true);
    const scorecard = scorecardData.find(item => item.scoreFormId === scoreFormId);
    if (scorecard) {
      console.log(scorecard, "scorecardsjfdhsdjf")
      setSelectedScorecard(scorecard);
      setIsShowDivVisible(true);

      const formSchema = JSON.parse(scorecard.form_schema);
      setFields(formSchema[0]?.fields || []);
      setFormula(scorecard.scorecard_categories?.[0]?.formula || '');
      const selectedCategory = scorecard.scorecard_categories?.[0]?.ScoreCardCategory || '';
      setFormValues({ category: selectedCategory });
      const id = String(scorecard?.categoryId)
      setSelectedCategoryId(id)
    }
  };


  const handleCancel = () => {
    setMode('')
    setIsShowDivVisible(false);
    setSelectedScorecard([]);
    setCopiedFields([]);
    setSelectedCategoryId('')
  }

  const handleAddNewClick = (index) => {
    setSelectedScorecard(null);  // Clear previous data
    setSelectedIndex(index + 1);
    setFormValues({ category: "", titleValue: "", descriptionValue: "" }); // Reset form fields
    setFields([]); // Clear any previously edited fields
    setFormula(""); // Reset formula field
    setMode("add");
    setIsShowDivVisible(true);
  };


  const fetchData = async () => {
        setLoading(true); // ✅ Start global loader

    try {
      const response = await axios.get(`${EXCHNAGE_URL}/allScorecard?eventId=${eventIdGet}&roundId=${roundId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      const data = response.data.data;
      setScorecardData(data);
      console.log(data, "scorecardData")

    } catch (error) {
      console.error('Error fetching data:', error);
    }finally {
      setLoading(false); // ✅ Stop global loader
    }
  };



  useEffect(() => {
    fetchData();
  }, [])

  const handleDeleteScoreCard = async (scoreFormId) => {
    const scorecard = scorecardData.find(item => item.scoreFormId === scoreFormId);
    if (scorecard) {
      setLoading(true); // ✅ Start global loader

      try {
        const scoreFormId = scorecard.scoreFormId;
        const response = await axios.delete(`${EXCHNAGE_URL}/scorecard/?scoreFormId=${scoreFormId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 200) {
          toast.success('Scorecard deleted successfully');
          setScorecardData((prevData) => prevData.filter(scorecard => scorecard.scoreFormId !== scoreFormId));

          setSelectedScorecard(null);

          setIsShowDivVisible(false);
        } else {
          toast.error('Failed to delete scorecard');
        }
      } catch (error) {
        toast.error('Error deleting scorecard');
      }finally {
        setLoading(false); // ✅ Stop global loader
      }
    }


  };

  const handleCancelEdit = () => {
    setSingleScoreCardData([]);
    setSelectedScorecard([]);
    setIsShowDivVisible(false);
    setIsEditModalVisible(false);
    setIsCreateCopyModalVisible(false);
    setCopiedFields([]);
    setMode('');
    setSelectedCategoryId('')
  }

  useEffect(() => {
    if (selectedScorecard && selectedScorecard.scoreFormId) {
      const scoreCardFetchData = async () => {
        const scoreFormId = selectedScorecard.scoreFormId;
                setLoading(true); // ✅ Start global loader

        try {
          const response = await axios.get(`${EXCHNAGE_URL}/scorecard?eventId=${eventIdGet}&scoreFormId=${scoreFormId}&roundId=${roundId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          const data = response.data.data;
          setSingleScoreCardData(data);
          setTitleValue(data.title);
          setDescriptionValue(data.description);
          setFields(data.form_schema ? JSON.parse(data.form_schema) : []);
          setFormula(data.overall_value || '');
          setCategories(data.scorecard_categories || []);
          console.log(categories, "categoriesssssssssss")

          console.log(data, "scorecardData")
        } catch (error) {
          console.error('Error fetching data:', error);
        }finally {
          setLoading(false); // ✅ Stop global loader
        }
      };
      scoreCardFetchData();
    }
    else {
      console.log('No selected scorecard or scoreFormId is missing');
    }
  }, [eventIdGet, roundId, selectedScorecard, token])

  useEffect(() => {
    console.log(categories, "Updated Categories");
  }, [categories]);

  useEffect(() => {
    if (scorecardData.length > 0) {
      const allFormFields = [];
      scorecardData.forEach((scorecard) => {
        if (scorecard.form_schema) {
          try {
            const parsedFormSchema = JSON.parse(scorecard.form_schema);

            parsedFormSchema.forEach((form) => {
              if (Array.isArray(form.fields)) {
                const extractedFields = form.fields.map((field) => ({
                  title: field.label === 'Title' ? field.value : null,
                  description: field.label === 'Description' ? field.value : null,
                  maxValue: field.maxValue || 'N/A',
                  minValue: field.minValue || 'N/A',
                }));

                allFormFields.push(...extractedFields.filter((field) => field.title || field.description));
              }
            });
          } catch (error) {
            console.error('Error parsing form schema:', error);
          }
        }
      });

      setFormFields(allFormFields);
    }
  }, [scorecardData]);

  useEffect(() => {
    setFields([...defaultFields]);
    getCategories();
  }, [initialEventId, searchTerm, sortOrder]);


  useEffect(() => {
    setNumFields(fields.length);
  }, [fields]);

  useEffect(() => {
    console.log("Current mode: ", mode);
  }, [mode]);

  return (
    <div className="create_jury_content_two">
      <div className="create_new_jury_button">
        <button onClick={handleAddNewClick} className="addNewButton">
          Add New ScoreCard
        </button>
      </div>

      {isShowDivVisible && mode == 'add' && (
        <>
          <div className="create_jury_content_two">
            <div className="create_jury_heading">
              <RedMainHeading>ScoreCard {totalScorecards + 1}</RedMainHeading>
            </div>

            <div className="create_jury_select_div">
              <InputLabel> Scorecard criteria </InputLabel>


              <div>
                <div className="formappp">
                  <div className="canvas-savee">
                    <FormCanvas
                      fields={fields}
                      updateField={updateField}
                      removeField={removeField}
                      onGenerateSchema={setGeneratedSchema}
                      titleValue={titleValue}
                      descriptionValue={descriptionValue}
                      updateTitleAndDescription={updateTitleAndDescription}
                    />
                    <div className="registratation_button">
                      <RedBackgroundButton onClick={addDefaultFields}>Add New Fields</RedBackgroundButton>
                    </div>
                  </div>
                </div>

                {currentField && (
                  <EditFieldModal
                    field={currentField}
                    onSave={(updatedField) => {
                      const updatedFields = fields.map((field) =>
                        field.dataName === updatedField.dataName ? updatedField : field
                      );
                      setFields(updatedFields);
                      setCurrentField(null);
                    }}
                    onClose={() => setCurrentField(null)}
                  />
                )}
              </div>
            </div>

            <div className="create_jury_select_div">
              <div className="create_jury_overall">
                <div className="create_juryoverall_head">
                  <InputLabel> Overall Scorecard Value </InputLabel>
                  <CheckLabel>
                    This is the calculated overall Scorecard value of a
                    submission
                  </CheckLabel>
                </div>
                <InputType type="text"
                  value={formula}
                  placeholder={`Enter formula using placeholders {1}, {2}, ...`}
                  onChange={handleFormulaInput}
                />
              </div>

              <div
                className="tooltip-container"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <FaInfoCircle className="info-icon" />

                <div className={`tooltip ${showTooltip ? 'visible' : ''}`}>
  By default, the Overall Scorecard Value of a submission is its total score, i.e. the sum of all the scores for each criteria.
  However, you can also do averages, e.g. (
  {"{1} + {2} + {3}"} / 3) where {"{1}"} is the score for criteria 1, {"{2}"} for criteria 2, and {"{3}"} for criteria 3.
</div>

              </div>

              <div className="create_jury_overall">
                <InputLabel>
                  Use this scorecard for the following Categories
                </InputLabel>

                <SelectBorder
                  name="category"
                  value={formValues.category}
                  onChange={handleChange}
                >
                  <option value="">Select a Category</option>
                  {allCategories.map((category) => (
                    <option
                      key={category.awardId}
                      value={category.category_name}
                      data-id={category.awardId}
                      disabled={selectedCategories.includes(category.awardId)}
                      className={selectedCategories.includes(category.awardId) ? 'category-disabled' : ''}
                    >
                      {category.category_name}
                    </option>
                  ))}
                </SelectBorder>

                {/* Show selected categories with cross */}
                <div className="selected-categories">
                  {selectedCategories.map((id) => {
                    const category = allCategories.find((cat) => cat.awardId === id);
                    return (
                      <span key={id} className="category-tag">
                        {category?.category_name}
                        <button
                          type="button"
                          onClick={() => removeCategory(id)}
                          className="remove-btn"
                        >
                          ✕
                        </button>
                      </span>
                    );
                  })}
                </div>
              </div>

            </div>

          </div>

          <div className="create_jury_btndiv">
            <GreyBorderButton
              onClick={handleCancel}
            >Cancel</GreyBorderButton>
            <RedBackgroundButton
              onClick={handelSubmit}
            >
              Create
            </RedBackgroundButton>
            {/* <GreyBackgroundButton onClick={() => {
              navigate("/jury-round");
            }}
            >Create & Add New
            </GreyBackgroundButton> */}
          </div>

        </>
      )}
      {isEditModalVisible && selectedScorecard && (
        <div className="create_jury_edit_form">
          <div className="create_jury_heading">
            <RedMainHeading>Edit Scorecard {selectedIndex}</RedMainHeading>
          </div>

          <div className="create_jury_select_div">
            <InputLabel>Scorecard criteria</InputLabel>

            <div>
              <FormCanvas
                fields={fields}
                updateField={updateField}
                removeField={removeField}
                onGenerateSchema={setGeneratedSchema}
                titleValue={selectedScorecard.titleValue}
                descriptionValue={selectedScorecard.description}
              />
              <div className="registratation_button">
                <RedBackgroundButton onClick={addDefaultFields}>Add New Fields</RedBackgroundButton>
              </div>
            </div>
          </div>

          <div className="create_jury_select_div">
            <div className="create_jury_overall">
              <InputLabel>Overall Scorecard Value</InputLabel>
              <CheckLabel>
                This is the calculated overall Scorecard value of a submission
              </CheckLabel>
              <InputType
                type="text"
                value={formula}
                placeholder="Enter formula using placeholders {1}, {2}, ..."
                onChange={handleFormulaInput}
              />
            </div>

            <div
              className="tooltip-container"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <FaInfoCircle className="info-icon" />

             <div className={`tooltip ${showTooltip ? 'visible' : ''}`}>
  By default, the Overall Scorecard Value of a submission is its total score, i.e. the sum of all the scores for each criteria.
  However, you can also do averages, e.g. (
  {"{1} + {2} + {3}"} / 3) where {"{1}"} is the score for criteria 1, {"{2}"} for criteria 2, and {"{3}"} for criteria 3.
</div>

            </div>

            <div className="create_jury_overall">
              <InputLabel>Use this scorecard for the following Categories</InputLabel>
              <SelectBorder
                name="category"
                value={formValues.category}
                onChange={handleChangeEdit}
              >
                <option value="">Select a Category</option>
                {allCategories.map((category) => (
                  <option key={category.awardId} value={category.category_name} data-id={category.awardId}>
                    {category.category_name}
                  </option>
                ))}
              </SelectBorder>
            </div>
          </div>

          <div className="create_jury_btndiv">
            <GreyBorderButton onClick={handleCancelEdit}>Cancel</GreyBorderButton>
            <RedBackgroundButton onClick={handleUpdate}>Update</RedBackgroundButton>
          </div>
        </div>
      )}

      {isCreateCopyModalVisible && mode == 'createCopy' && (
        <>
          <div className="create_jury_content_two">
            <div className="create_jury_heading">
              <RedMainHeading>ScoreCard {totalScorecards + 1}</RedMainHeading>
            </div>

            <div className="create_jury_select_div">
              <InputLabel> Scorecard criteria </InputLabel>


              <div>
                <div className="formappp">
                  <div className="canvas-savee">
                    <FormCanvas
                      fields={fields}
                      updateField={updateField}
                      removeField={removeField}
                      onGenerateSchema={setGeneratedSchema}
                      titleValue={titleValue}
                      descriptionValue={descriptionValue}
                      updateTitleAndDescription={updateTitleAndDescription}
                    />
                    <div className="registratation_button">
                      <RedBackgroundButton onClick={addDefaultFields}>Add New Fields</RedBackgroundButton>
                    </div>
                  </div>
                </div>

                {currentField && (
                  <EditFieldModal
                    field={currentField}
                    onSave={(updatedField) => {
                      const updatedFields = fields.map((field) =>
                        field.dataName === updatedField.dataName ? updatedField : field
                      );
                      setFields(updatedFields);
                      setCurrentField(null);
                    }}
                    onClose={() => setCurrentField(null)}
                  />
                )}
              </div>
            </div>

            <div className="create_jury_select_div">
              <div className="create_jury_overall">
                <div className="create_juryoverall_head">
                  <InputLabel> Overall Scorecard Value </InputLabel>
                  <CheckLabel>
                    This is the calculated overall Scorecard value of a
                    submission
                  </CheckLabel>
                </div>
                <InputType type="text"
                  value={formula}
                  placeholder={`Enter formula using placeholders {1}, {2}, ...`}
                  onChange={handleFormulaInput}
                />
              </div>

              <div className="create_jury_overall">
                <InputLabel>
                  Use this scorecard for the following Categories
                </InputLabel>
                <SelectBorder
                  name="category"
                  value={formValues.category}
                  onChange={handleChangeEdit}>
                  <option value="">Select a Category</option>
                  {allCategories.map((category) => (
                    <option key={category.awardId} value={category.category_name} data-id={category.awardId}>
                      {category.category_name}
                    </option>
                  ))}
                </SelectBorder>
              </div>
            </div>

          </div>

          <div className="create_jury_btndiv">
            <GreyBorderButton
              onClick={handleCancel}
            >Cancel</GreyBorderButton>
            <RedBackgroundButton
              onClick={handelSubmitCopy}
            >
              Create copy
            </RedBackgroundButton>
          </div>

        </>
      )}


      <div className="create_jury_get_div">
        {scorecardData?.map((scorecard, index) => (
          <div key={index} className="create_jury_gettwo_main">
            <div className="create_jury_heading">
              <RedMainHeading>Scorecard {index + 1}</RedMainHeading>
            </div>
            <div className="create_jury_gettwo_div">
              {scorecard.scorecard_categories?.map((category, categoryIndex) => (
                <CheckLabel key={categoryIndex}>
                  {category.ScoreCardCategory}
                </CheckLabel>
              ))}
              <div className="create_jury_gettwo_sub">
                <MdEditSquare
                  onClick={() => handleEditButtonClick(scorecard.scoreFormId, index)}
                />
                <IoCopy onClick={() => handleCopyButtonClick(scorecard.scoreFormId)} />
                <RiDeleteBin6Fill onClick={() => handleDeleteScoreCard(scorecard.scoreFormId)} />
              </div>
            </div>

            <div className="create_jury_getthree_div">
              {JSON.parse(scorecard.form_schema).map((schema, schemaIndex) => (
                <div key={schemaIndex}>
                  {schema.fields.map((field, fieldIndex) => (
                    <CheckLabel key={fieldIndex}>
                      <div>
                        {field.label === 'Title' && <p>Title: {field.value}</p>}
                        {field.maxValue && <p>Max Value: {field.maxValue}</p>}
                        {field.minValue && <p>Min Value: {field.minValue}</p>}
                      </div>
                    </CheckLabel>
                  ))}
                </div>
              ))}
            </div>

          </div>

        ))}
      </div>


      <div className="create_jury_btndiv">
        <GreyBorderButton
          onClick={() => {
            navigate("/jury-round");
          }}
        >
          Back to Jury Rounds
        </GreyBorderButton>

        {isShowDivVisible && (
          <RedBackgroundButton
            onClick={() => {
              navigate(`/successfully-created-judge-round`);
            }}
          >
            {" "}
            Update{" "}
          </RedBackgroundButton>
        )}
      </div>
    </div>
  )
}

export default ScoreCardData

